<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="常用数据" name="first">
      <HistoryNormal v-if="activeName === 'first'" />
    </el-tab-pane>
    <el-tab-pane label="设备轨迹" name="second">
      <HistoryOther v-if="activeName === 'second'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import HistoryNormal from "./historyDataNormal.vue";
import HistoryOther from "./historyDataOther.vue";
export default {
  components: { HistoryNormal, HistoryOther },

  data() {
    return {
      activeName: this.$route.query.active || "first"
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/historyData.vue